<template>
  <div class="container">
    <div></div>
    <div
      class="top"
      @click="backClick"
    >
      <div class="topSub">
        <img
          src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png"
          crossorigin="Anonymous"
        />
        <div>返回</div>
      </div>
    </div>
    <div class="listTop">待审核话术：{{ list.length }}条</div>
    <div class="list">
      <div
        v-for="(item, idx) in list"
        class="listItem"
        :key="item.id"
      >
        <div class="listItemT">
          <img
            class="listItemTL"
            :src="item.faceIcon"
          />
          <div class="listItemTM">{{ item.nickname }}</div>
          <div
            v-if="item.type == 1"
            class="listItemTR"
          >
            新增话术
          </div>
          <div
            v-else-if="item.type == 2"
            class="listItemTR listItemTR2"
          >
            修改话术
          </div>
        </div>
        <div class="listItemT2">
          <img
            src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"
          />
          {{ item.title }}
        </div>
        <div class="listItemT3"></div>
        <pre
          v-html="item.newSpeechText"
          class="listItemT4"
        ></pre>
        <div class="listItemB">
          <div class="listItemBL">分类：{{ item.labelName }}</div>
          <div class="listItemBR">
            <div
              class="listItemBBtn red"
              @click="refuseClick(idx)"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250821182438.png"
              />
              <div>拒绝</div>
            </div>
            <div
              class="listItemBBtn blue"
              @click="modifyClick(idx)"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250821182549.png"
              />
              <div>修改</div>
            </div>
            <div
              class="listItemBBtn green"
              @click="agreeClick(idx)"
            >
              <img
                src="https://imagessl.lingtuo.cn/A-1ed71af7_20250821182604.png"
              />
              <div>通过</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="huashuEditShow"
      class="huashuEditDialogCover"
    >
      <div class="huashuEditDialogCoverMain">
        <huashu-edit
          :isWeb="true"
          :labelIdProps="currentItem.labelId"
          :speechIdProps="currentItem.speechId"
          :checkId="currentItem.checkId"
          @huashuEditClose="huashuEditClose"
          @huashuEditSuccess="huashuEditSuccess"
        ></huashu-edit>
      </div>
    </div>
  </div>
</template>

<script>
import HuashuEdit from "./HuashuEdit";

export default {
  props: [],
  data() {
    return {
      list: [],
      huashuEditShow: false,
      currentItem: null,
      page: 1,
      pageSize: 20,
      typeList: [],
    };
  },
  components: {
    HuashuEdit,
  },
  methods: {
    huashuEditClose() {
      this.huashuEditShow = false;
    },
    huashuEditSuccess() {
      this.$message({
        message: "提交成功",
        type: "success",
      });
      setTimeout(() => {
        this.huashuEditShow = false;
        window.location.reload();
      }, 1000);
    },
    async refuseClick(idx) {
      this.$prompt("", "拒绝原因", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "拒绝原因不能为空",
      })
        .then(async ({ value }) => {
          this.currentItem = this.list[idx];
          this.currentItem.refuseReason = value;
          await this.huashuCheck(1);
          this.$message({
            message: "提交成功",
            type: "success",
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(() => {});
    },
    async agreeClick(idx) {
      this.currentItem = this.list[idx];
      await this.huashuCheck(0);
      this.$message({
        message: "提交成功",
        type: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    async huashuCheck(isRefuse) {
      return new Promise(async (resolve, reject) => {
        let params = {
          speechId: this.currentItem.speechId,
          checkId: this.currentItem.checkId,
          isRefuse: isRefuse,
        };
        if (isRefuse) {
          params.refuseReason = this.currentItem.refuseReason;
        }
        let resp = await this.$http.huashuReviewCheck(params);
        if (resp.code == 200) {
          resolve();
        }
      });
    },
    modifyClick(idx) {
      this.currentItem = this.list[idx];
      localStorage.setItem("editHuashuData", JSON.stringify(this.currentItem));
      this.huashuEditShow = true;
    },
    backClick() {
      this.$router.go(-1);
    },
    // 提取文件后缀的辅助函数
    getFileExtension(url) {
      const path = url.split("/");
      const fileName = path[path.length - 1];
      const parts = fileName.split(".");

      if (parts.length > 1) {
        return parts.pop();
      }

      return "";
    },
    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },
    getFileIcon(fileName) {
      let icon = "";
      if (fileName.includes(".doc")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png";
      } else if (fileName.includes(".txt")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png";
      } else if (fileName.includes(".xls")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png";
      } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png";
      } else if (fileName.includes(".pdf")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png";
      } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png";
      } else {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png";
      }
      return icon;
    },
    //type: img、video、file
    getContentEditorFileItem(path, type, file) {
      const fileElement = document.createElement("div");
      fileElement.setAttribute("id", path);
      fileElement.setAttribute("contenteditable", "false");

      if (type == "img") {
        // fileElement.setAttribute('style', `background-image: url(${path})`);
        // fileElement.setAttribute('class', 'contentImgItem');
        const imgEle = document.createElement("img");
        imgEle.setAttribute("class", "contentImgItemImg");
        imgEle.setAttribute("src", path);
        fileElement.setAttribute("class", "contentImgItem");
        fileElement.appendChild(imgEle);
      } else if (type == "video") {
        const videoEle = document.createElement("video");
        videoEle.setAttribute("src", path);
        fileElement.setAttribute("class", "contentVideoItem");
        fileElement.appendChild(videoEle);
        const videoIconEle = document.createElement("img");
        videoIconEle.setAttribute(
          "src",
          "https://imagessl.edujia.com/A-1ed71af7_20231013134229.png"
        );
        videoIconEle.setAttribute("class", "contentVideoItemIcon");
        fileElement.appendChild(videoIconEle);
      } else if (type == "videoPreview") {
        fileElement.setAttribute("style", `background-image: url(${path})`);
        fileElement.setAttribute("class", "contentVideoPrviewItem");
      } else if (type == "file") {
        const fileoEle = document.createElement("div");
        fileElement.appendChild(fileoEle);
        const iconEle = document.createElement("img");
        iconEle.src = this.getFileIcon(file.file.name);
        iconEle.setAttribute("class", "contentFileItemIcon");
        fileElement.appendChild(iconEle);
        const nameEle = document.createElement("div");
        nameEle.innerHTML = file.file.name;
        nameEle.setAttribute("class", "contentFileItemLabel");
        fileElement.appendChild(nameEle);
        fileElement.setAttribute("class", "contentFileItem");
      }
      return fileElement;
    },
    async qryHuashuList() {
      return new Promise(async (resolve, reject) => {
        let params = {
          page: this.page,
          pageSize: this.pageSize,
          speechId: localStorage.getItem("lastSelSpeechId"),
          status: 0, //状态：0待审核，1拒绝，默认0
        };
        let resp = await this.$http.huashuReview(params);
        if (resp.code == 200) {
          let list = resp.data.array.map((val) => {
            let typeResult = this.typeList.find((type) => {
              return type.labelId == val.labelId;
            });
            if (typeResult) {
              val.labelName = typeResult.labelName;
            }
            let eleList = [];
            let text = val.speechText;
            text = this.replaceAll(text, "<分段>", "");
            text = this.replaceAll(text, "\n", "<br>");
            text = this.replaceAll(text, "\\n", "<br>");
            const urlRegex =
              /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
            let match;
            let lastPart = text;
            let newText = "";
            while ((match = urlRegex.exec(text)) !== null) {
              let url = match[0];
              const fileExtension = this.getFileExtension(url);

              // 只添加具有正确文件后缀的URL
              if (
                fileExtension === "png" ||
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileExtension === "pdf" ||
                fileExtension === "doc" ||
                fileExtension === "docx" ||
                fileExtension === "dotm" ||
                fileExtension === "dotx" ||
                fileExtension === "dotm" ||
                fileExtension === "txt" ||
                fileExtension === "xlsx" ||
                fileExtension === "xls" ||
                fileExtension === "mp4" ||
                fileExtension === "mov" ||
                fileExtension === "mp3" ||
                fileExtension === "m4a" ||
                fileExtension === "aac" ||
                fileExtension === "caf" ||
                fileExtension === "ppt" ||
                fileExtension === "pptx"
              ) {
                let tmp = lastPart.split(url);
                // console.log("tmp==",tmp[0]);
                if (
                  fileExtension === "jpg" ||
                  fileExtension === "png" ||
                  fileExtension === "jpeg"
                ) {
                  let fileElement = this.getContentEditorFileItem(url, "img");
                  newText += tmp[0] + fileElement.outerHTML;
                  lastPart = tmp[1];
                } else if (fileExtension === "mp4") {
                  eleList.push({
                    type: "video",
                    val: url,
                  });
                } else if (fileExtension === "mp3" || fileExtension === "m4a") {
                  let tmpUrl = new URL(url);
                  let fileName = tmpUrl.pathname.split("/").pop();
                  let fileElement = this.getContentEditorFileItem(url, "file", {
                    file: {
                      name: fileName,
                    },
                  });
                  newText += tmp[0] + fileElement.outerHTML;
                  lastPart = tmp[1];

                  // let eleIdx = eleList.length;
                  // let tmpUrl = new URL(url);
                  // let fileName = tmpUrl.pathname.split("/").pop();
                  // let audio = new Audio();
                  // audio.src = url;
                  // audio.id = "audio" + eleIdx;
                  // let id = new Date().getTime();
                  // eleList.push({
                  //   type: "audio",
                  //   val: url,
                  //   fileName: fileName,
                  //   fileIcon: this.getFileIcon(fileName),
                  //   id: id,
                  // });
                  // audio.muted = true;
                  // audio.play().then(() => {
                  //   audio.pause();
                  // });
                  // audio.muted = false;
                  // audio.addEventListener("loadedmetadata", () => {
                  //   console.log("audio duration==", audio.duration);
                  //   this.eleList.forEach((ele, idx) => {
                  //     if (ele.id == id) {
                  //       this.eleList.splice(idx, 1, {
                  //         type: "audio",
                  //         val: url,
                  //         fileName: fileName,
                  //         fileIcon: this.getFileIcon(fileName),
                  //         duration: audio.duration * 1000,
                  //       });
                  //     }
                  //   });
                  // });
                  // this.audioList.push(audio);
                } else {
                  // let tmpUrl = new URL(url);
                  // const fileName = tmpUrl.pathname.split("/").pop();
                  // eleList.push({
                  //   type: "file",
                  //   val: url,
                  //   fileName: fileName,
                  //   fileIcon: this.getFileIcon(fileName),
                  // });
                  let tmpUrl = new URL(url);
                  let fileName = tmpUrl.pathname.split("/").pop();
                  let fileElement = this.getContentEditorFileItem(url, "file", {
                    file: {
                      name: fileName,
                    },
                  });
                  newText += tmp[0] + fileElement.outerHTML;
                  lastPart = tmp[1];
                }
              }
            }
            val.newSpeechText = newText + lastPart;
            return val;
          });
          this.list.splice(this.list.length, 0, ...list);
          resolve();
        } else {
          resolve([]);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("typeList")) {
      this.typeList = JSON.parse(localStorage.getItem("typeList"));
    }
    this.qryHuashuList();
  },
  async mounted() {},
};
</script>

<style>
.el-message {
  z-index: 99999 !important;
}

.contentImgItem {
  width: 110px;
  height: 110px;
  position: relative;
  background-size: 110px 110px;
  background-repeat: no-repeat;
  margin: 10px;
}

.contentImgItemImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.contentVideoPrviewItem {
  width: 110px;
  height: 110px;
  position: relative;
  background-size: 110px 110px;
  background-repeat: no-repeat;
  margin: 10px;
}

.contentImgItemImg {
  width: 100%;
  height: 100%;
}

.contentVideoItem {
  width: 110px;
  height: 110px;
  position: relative;
  margin: 10px;
  background-color: #000;
}

.contentVideoItem video {
  width: 100%;
  height: 100%;
}

.contentVideoItemIcon {
  width: 44px !important;
  height: 44px !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.contentFileItem {
  width: 350px;
  height: 70px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin: 10px;
  position: relative;
}

.contentFileItemIcon {
  width: 39px;
  height: 39px;
  margin-left: 20px;
}

.contentFileItemLabel {
  margin-left: 14px;
  width: 255px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  color: #3c3c3c;
}

.contentImgItemDel {
  width: 14px;
  height: 14px;
  border-radius: 14px;
  overflow: hidden;
  background-size: 14px 14px;
  background-repeat: no-repeat;
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #fff;
}
</style>

<style scoped>
.container {
  width: 100%;
  height: 100vh;
  background-color: #f5f6f6;
}

.top {
  width: 100%;
  height: 64px;
  color: #4a90e2;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 25px;
  position: fixed;
  left: 0;
  top: 0px;
  background-color: #fff;
  z-index: 9999;
}

.topSub {
  margin-left: 50%;
  transform: translateX(-604px);
  display: flex;
  align-items: center;
}

.top img {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}

.list {
  width: 1208px;
  height: calc(100vh - 112px);
  background-color: #fff;
  position: relative;
  padding-top: 112px;
  overflow: scroll;
  margin-left: 50%;
  transform: translateX(-604px);
}

.listTop {
  height: 48px;
  background-color: #fcf6df;
  color: #fb5d5c;
  display: flex;
  align-items: center;
  text-indent: 16px;
  position: fixed;
  top: 64px;
  left: 50%;
  transform: translateX(-604px);
  width: 1208px;
  z-index: 9999;
}

.listItem {
  margin: 16px 20px;
  border-bottom: 1px solid #e5e5e5;
}

.listItemT {
  display: flex;
  align-items: center;
}

.listItemTL {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  margin-right: 8px;
}

.listItemTM {
  margin-right: 12px;
  font-size: 16px;
  font-weight: 500;
}

.listItemTR {
  font-size: 14px;
  font-weight: 500;
  color: #43a046;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: #e1f1e1;
}

.listItemTR2 {
  color: #ffa000;
  background-color: #fcf6df;
}

.listItemT2 {
  display: flex;
  align-items: center;
  color: #3c3c3c;
  font-size: 16px;
  font-weight: 500;
}

.listItemT2 img {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}

.listItemT4 {
  white-space: pre-wrap;
}

.listItemB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  padding-bottom: 21px;
}

.listItemBL {
  display: flex;
  align-items: center;
  color: #808080;
  font-size: 16px;
}

.listItemBR {
  display: flex;
  align-items: center;
}

.listItemBBtn {
  display: flex;
  align-items: center;
  margin-left: 37px;
  font-size: 16px;
}

.listItemBBtn img {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}

.red {
  color: #fb5d5c;
}

.blue {
  color: #4a90e2;
}

.green {
  color: #43a046;
}

.huashuEditDialogCover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.huashuEditDialogCoverMain {
  width: 1000px;
  height: 800px;
  position: relative;
  background-color: #fff;
}
</style>
